
    import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
    import ListBase from '@/lib/listbase';
    import Util from '@/lib/util';
    import VWidget from '@/components/VWidget.vue';
    import VueApexCharts from 'vue-apexcharts'

    @Component({
        components: { apexcharts: VueApexCharts, VWidget },
    })

    export default class TablesStats extends ListBase {
        options: any = {
            chart: {
                height: 250,
                type: 'line',
                zoom: {
                    enabled: false
                }
            },
            dataLabels: {
                enabled: true,
                formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                    return new Intl.NumberFormat().format(value)
                }
            },
            stroke: {
                curve: 'straight'
            },
            title: {
                text: 'Respuestas',
                align: 'center'
            },
            grid: {
                row: {
                    colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
            },
            xaxis: {
                type: 'text',
                categories: this.monthsRange
            },
            legend: {
                position: 'top',
                horizontalAlign: 'center',
                floating: true,
                offsetY: -15
            }
        };

        get monthsRange() {
            let list = this.gCommonList('months');
            let months = [];
            list.forEach(item => {
                months.push(item.name.substr(0,3));
            });

            return months;
        }

        get series() {
            let list = [];
            this.$store.state.quiz.postventa.forEach((item, k) => {
                if (k > 0 && k < 4) {
                    let values = [];
                    for (var i = 1; i <= 12; i++)
                        values.push(item['month_' + i]);

                    list.push({
                        name: item.name,
                        data: values
                    });
                }
            });
            return list;
        }

        get loading() {
            return this.$store.state.quiz.loading;
        }

        loadData() {
            this.$emit('load-data');
        }

        mounted() { 
        }
     }
